<mat-slide-toggle
  class="custom-theme-switch"
  [checked]="activeTheme === EUserTheme.dark"
  (change)="toggleTheme()"
  color="primary"
  labelPosition="before"
  >{{ 'toolbar.theme' | translate }}
</mat-slide-toggle>
